import { useSetState } from '@domain-group/react-hooks'

import { isValidEmail, toggleArray } from '@domain-group/javascript-utils'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button, Form, SidebarModalListItem } from '@domain-group/suit-theme'

import { CustomDeadlineModel } from '@domain-group/realhub-backend-api-types'

type DefaultStateType = {
  errorMessage: string,
  newEmail: string,
}

interface EmailRecipientsProps {
  entityState: Partial<CustomDeadlineModel>,
  setEntityState: ({ alert_emails }:{alert_emails: Array<string>}) => void,
  }

type AddEmailParams = {
  alert_emails: string[],
  e?: KeyboardEvent,
  state: DefaultStateType,
  setEntityState: ({ alert_emails }:{ alert_emails: Array<string> }) => void,
  setState: (state: Partial<DefaultStateType>) => void,
}

const addEmail = (params: AddEmailParams) => {
  const {
    alert_emails = [], state, setEntityState, setState,
  } = params

  const { newEmail } = state
  if (!isValidEmail(newEmail)) return setState({ errorMessage: 'Invalid Email' })

  setEntityState({ alert_emails: toggleArray(alert_emails, newEmail) })
  setState({ errorMessage: '', newEmail: '' })
}

const handleKeyDown = (params: AddEmailParams) => {
  const { e } = params

  // @ts-expect-error TS2339
  if (e?.key === 'Enter' && e?.target?.value !== ''){
    e?.preventDefault()
    addEmail(params)
  }
}

const defaultState: DefaultStateType = {
  errorMessage: '',
  newEmail: '',
}

const EmailRecipients = (props: EmailRecipientsProps) => {
  const [state, setState] = useSetState(defaultState)
  const { errorMessage, newEmail } = state

  const { entityState, setEntityState } = props
  const { alert_emails = [] } = entityState

  return (
    <Form.Field label="Add Email Recipient" marginTop="large" errorMessage={errorMessage}>
      <input
        type="text"
        value={newEmail}
        // @ts-expect-error TS2322
        onKeyDown={(e: KeyboardEvent) => handleKeyDown({
          alert_emails, e, state, setEntityState, setState,
        })}
        onChange={e => setState({ newEmail: e.target.value })}
      />

      <Button
        buttonStyle="ghostEdit"
        disabled={!isValidEmail(newEmail)}
        icon={<FontAwesomeIcon icon={faPlus} />}
        // @ts-expect-error
        marginTop="medium"
        onClick={() => addEmail({
          alert_emails, state, setEntityState, setState,
        })}
        size="medium"
      >
        Add Email
      </Button>

      {alert_emails.map(email => (
        <SidebarModalListItem key={email} title={email}>
          {/*
           // @ts-expect-error TS2339 */}
          <SidebarModalListItem.Actions>
            {/*
             // @ts-expect-error TS2339 */}
            <SidebarModalListItem.Icon
              onClick={() => setEntityState({ alert_emails: toggleArray(alert_emails, email) })}
              type="delete"
            />
            {/*
           // @ts-expect-error TS2339 */}
          </SidebarModalListItem.Actions>
        </SidebarModalListItem>
      ))}
    </Form.Field>
  )
}

export default EmailRecipients
